/*

Renders into the #root element.

*/

import './index.css';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import Router from './components/Router';
import { load as loadContent } from './services/content';
import { load as loadLang } from './services/lang';
import './services/analytics';

Promise.all([
    loadContent(),
    loadLang()
]).then(() => {
    ReactDOM.render(<Router/>,  document.getElementById('root'));
});


// WEBPACK FOOTER //
// ./src/index.js